export default __webpack_public_path__ + "static/hero-bg-video-track-61631b1f2e56d5764d4a4866af68ea9a.mp4";